const SvgPolandOutlined = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 61 60">
    <path stroke="#373737" d="M32.446 10.31V6.414l1-.966 10.8 1.449.981-2.966L31.973 2 3.5 12.138v29.448L40.318 58 57.5 42.069V10.31z" />
  </svg>;
export default SvgPolandOutlined;